module.exports = __webpack_public_path__ + "img/ET411-3开打印头.629.5f6eeaf7.png";